export default "__VITE_ASSET__CwhkeHzn__"